import { gql } from '@apollo/client';

export const GENERATE_UPLOAD_URL = gql`
  mutation GenerateUploadUrl($filename: String!, $contentType: String!) {
    generateUploadUrl(filename: $filename, contentType: $contentType)
  }
`;

export const UPDATE_IMAGE = gql`
    mutation UpdateImage($id: ID!, $url: String!) {
      updateImage( url: $url, id:$id) {
      url  
      }
    }
`;

export const DELETE_IMAGE = gql`
  mutation DeleteImage($filename: String!, $id: ID!) {
    deleteImage(filename: $filename, id: $id)
  }
`;